import { Correction } from "../../Request/DcfRequestReducer";

export enum WizardActionTypes {
    Next = "next",
    Previous = "previous",
    Reset = "reset"
}

export interface WizardState {
    page: number;
}

export interface CorrectionItemPreviewProps {
    corrections: Correction[]
}

export interface CorrectionItemPreview {
    previewElement: any;
    previewSelector: (corrections: Correction[]) => boolean
}
